module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/angulargauge/angulargauge.component.scss
// module id = ./src/app/shared/components/widgets/angulargauge/angulargauge.component.scss
// module chunks = main